// bao migrate skip
import * as $ from "jquery";
import * as ko from "knockout";
import Bao from "../../../services/bao-service";
import BaoRouter from "../../../services/bao-router";
import finitoService from "../../../services/finito-service";
import BaoDialog from "../../../factories/bao-dialog";

function RoleTaskRecipientRole(tabpage, parent) {
    var self = this;
    self.TabPage = tabpage;
    self.Role = parent;
    self.initialized = false;
    self.TaskRecipientCollection = ko.observableArray([]);
    self.Sorting = ko.observableArray([]);
    self.PageIndex = ko.observable(0);
    self.PageSize = ko.observable(10);
    self.TotalRows = ko.observable(0);
    self.SelectedTaskRecipientRow = ko.observable();
    self.ToolbarButtons = ko.observableArray([]);
    self.ShowRoleDialog = function () { };
    self.SelectedRole = ko.observable();
    self.SelectedRoleIds = ko.observable();
    self.baoSearcherItems = ko.observableArray([]);
    self.SelectedRole.subscribe(function () {
        if (self.SelectedRole() === null || self.SelectedRole().length == 0) {
            return;
        }
        self.AddRoleTaskRecipientRole(self.SelectedRole(), self.Role.RoleId()).then(function () {
            self.loadTaskRecipientCollection();
            self.SelectedRole([]);
            self.baoSearcherItems([]);
        });
    });
    self.SelectTaskRecipientRow = function (clickedRow) {
        this.SelectedTaskRecipientRow(clickedRow);
        return true;
    };
    self.Sorting.subscribe(function () {
        self.loadTaskRecipientCollection();
    });
    self.PageIndex.subscribe(function () {
        self.loadTaskRecipientCollection();
    });
    self.SelectedTaskRecipientRow.subscribe(function () {
        self.ToggleToolbarButtons();
    });
    self.ToolbarButtons.subscribe(function () {
        self.ToggleToolbarButtons();
    });
    self.ShowTaskRecipientRole = function (item) {
        var linkHash = "uadm/role/" + ko.unwrap(item.TaskRecipientRoleId);
        BaoRouter.setHash(linkHash);
    };
    self.CompleteCheck = function () {
        return true;
    };
    self.resetServerCollection = function () {
        return Bao.post("UadmFinitoCustom/RoleTab/ResetRoleTaskRecipientRoleServiceProviderCollection", JSON.stringify({
            sessionTabId: ko.unwrap(self.Role.TabPage.SessionTabId)
        }));
    };
    self.loadTaskRecipientCollection = function (forceRefresh) {
        if (self.initialized !== true && forceRefresh !== true) {
            return;
        }
        return Bao.post("UadmFinitoCustom/RoleTab/GetTaskRecipientCollection", JSON.stringify({
            sessionTabId: ko.unwrap(self.Role.TabPage.SessionTabId),
            roleId: ko.unwrap(self.Role.RoleId),
            searchFilter: "",
            pageIndex: ko.unwrap(self.PageIndex),
            pageSize: ko.unwrap(self.PageSize),
            sorting: ko.unwrap(self.Sorting)
        }), function (data) {
            self.TotalRows(data.TotalRows);
            self.TaskRecipientCollection(data.Models);
        });
    };
    self.MinifyTaskRecipients = function (taskRecipients) {
        taskRecipients = ko.unwrap(taskRecipients);
        if (taskRecipients == null || taskRecipients == false || taskRecipients.length == 0) {
            return [];
        }
        var result = [];
        for (var i in taskRecipients) {
            if (taskRecipients[i].ShiftbookId != "" && taskRecipients[i].ShiftbookId != null) {
                result.push(taskRecipients[i].ShiftbookId);
            }
            else {
                result.push(taskRecipients[i].RoleId);
            }
        }
        return result;
    };
    self.AddRoleTaskRecipientRole = function (taskRecipients, roleId) {
        return Bao.post("UadmFinitoCustom/RoleTab/AddTaskRecipientRole", JSON.stringify({
            sessionTabId: ko.unwrap(self.Role.TabPage.SessionTabId),
            roleId: roleId,
            taskRecipients: self.MinifyTaskRecipients(taskRecipients)
        }), function (data) {
            self.Role.TabPage.DirtyFlag(true);
            if (data !== true) { }
        });
    };
    self.DeleteRoleTaskRecipientRole = function (roleTaskRecipientRoleId, roleId) {
        var def = $.Deferred();
        Bao.post("UadmFinitoCustom/RoleTab/DeleteTaskRecipientRole", JSON.stringify({
            sessionTabId: ko.unwrap(self.Role.TabPage.SessionTabId),
            roleId: roleId,
            roleTaskRecipientRoleId: roleTaskRecipientRoleId
        }), function (data) {
            self.Role.TabPage.DirtyFlag(true);
            if (data !== true) { }
            def.resolve();
        });
        return def.promise();
    };
    self.Save = function () {
        return Bao.post("UadmFinitoCustom/RoleTab/SaveRoleTaskRecipientRoleServiceProviderCollection", JSON.stringify({
            sessionTabId: self.Role.TabPage.SessionTabId,
            roleId: self.Role.RoleId(),
            saveTime: parent.SaveTime()
        }));
    };
    self.Refresh = function (forceRefresh) {
        var def = $.Deferred();
        if (self.initialized !== true && forceRefresh !== true) {
            return;
        }
        self.TabPage.IsLoading(true);
        self.SelectedTaskRecipientRow(null);
        self.resetServerCollection().then(function () {
            self.loadTaskRecipientCollection(forceRefresh).then(function () {
                self.TabPage.IsLoading(false);
                def.resolve();
            });
        });
        return def.promise();
    };
    self.toolbarClick = function (btnClicked) {
        switch (ko.unwrap(btnClicked.ActionKey)) {
            case "RoleTaskRecipientAdd":
                self.ShowRoleDialog();
                break;
            case "RoleTaskRecipientDelete":
                var dialog = new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage(finitoService.MessageKeys.RoleTaskRecipientRoleDeletePrompt), "yesno");
                dialog.DialogResult.subscribe(function (dialogResult) {
                    if (dialogResult === true) {
                        self.DeleteRoleTaskRecipientRole(ko.unwrap(self.SelectedTaskRecipientRow).RoleTaskRecipientRoleId, ko.unwrap(self.Role.RoleId)).then(self.loadTaskRecipientCollection);
                    }
                });
                break;
            case "RoleTaskRecipientEdit":
                self.ShowTaskRecipientRole(ko.unwrap(self.SelectedTaskRecipientRow));
                break;
        }
    };
    self.ToggleToolbarButtons = function () {
        ko.utils.arrayForEach(self.ToolbarButtons(), function (button: any) {
            switch (button.ActionKey()) {
                case "RoleTaskRecipientEdit":
                case "RoleTaskRecipientDelete":
                    button.Enabled(!(self.SelectedTaskRecipientRow() == null));
                    break;
                case "RoleTaskRecipientAdd":
                    button.Enabled(!self.Role.IsNew());
                    break;
            }
        });
    };
    self.init = function () {
        self.Refresh(true);
    };
    self.loaded = function () {
        self.initialized = true;
    };
    self.dispose = function () { };
}
;
export default RoleTaskRecipientRole;